import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`text-xs uppercase tracking-[0.24em] font-mono font-medium ${
      dark ? "text-sand" : "text-teal"
    }`}
  >
    {children}
  </p>
);
